import {
  IOpenSnackbarAction,
  Severity,
  OPEN_SNACKBAR,
  CLOSE_SNACKBAR,
  ICloseSnackbarAction,
} from './types'

export const openSnackbar = (
  message: string,
  severity: Severity,
  time = 4000
): IOpenSnackbarAction => ({
  type: OPEN_SNACKBAR,
  message,
  severity,
  time,
})

export const closeSnackbar = (): ICloseSnackbarAction => ({
  type: CLOSE_SNACKBAR,
})
